export enum ReceiptStatus {
  created = 'created',
  issued = 'issued',
}

interface IReceiptUnitPrice {
  amount: string
  currency: string
  formatted: string
  symbol: string
}

interface IReceiptCart {
  quantity: number
  item: string
  tax: number
  unitPrice: IReceiptUnitPrice
}

interface IReceiptTotal {
  subTotal: IReceiptUnitPrice
  tax: IReceiptUnitPrice
  total: IReceiptUnitPrice
}

export interface IReceipt {
  id?: string
  issuedAt?: string
  status: ReceiptStatus
  type: string
  cart: IReceiptCart[]
  price: IReceiptTotal
}

export interface IReceiptOrganizer {
  companyName: string
  vatNumber: string
}

export interface IReceiptData {
  transactionCode: string
  organizer: IReceiptOrganizer
  receipts: IReceipt[]
}

export interface IReceiptResponse {
  data: IReceiptData
  status: number
}
